export default "__VITE_ASSET__DfOex87R__"